import React, { useRef, useState, useEffect } from 'react';

import SatSignPad from '@components/common/satUI/SatSignPad';
import SatButton from '@components/common/satUI/SatButton';
import SatQuestionArea from '@components/common/satUI/SatQuestionArea';
import SatCheckBox from '@components/common/satUI/SatCheckBox';

const ConstractChangePopup = props => {
  const {
    searchSignData,
    complete,
    signPasteData,
    searchPasteSignData,
    onSave,
    signData,
    ownerName,
    isPracticeMode,
    practiceSignName,
    practiceSignature,
  } = props;

  const reportId = 'app_form_etc_42';

  const canvasSignNameRef = useRef();
  const canvasSignatureRef = useRef();

  const [allCheckYN, setAllCheckYN] = useState(false);
  const [questionData, setQuestionData] = useState([]);
  const [showErrorCheckMsg, setShowErrorCheckMsg] = useState(false);

  const [pasteCheck, setPasteCheck] = useState(false); // 붙여넣기 체크 여부
  const [signNameData, setSignNameData] = useState(''); // 성명
  const [signatureData, setSignatureData] = useState(''); // 서명
  const [todayData, setTodayData] = useState(''); // 서명

  useEffect(() => {
    if (
      complete &&
      (!signData.sup_rpt_04_signid_05 || !signData.sup_rpt_04_signid_06)
    ) {
      !isPracticeMode &&
        searchSignData(
          reportId,
          `${reportId}_signid_02`,
          `${reportId}_signid_01`,
        ); // 완료된 페이지의 경우 기존 저장된 서명데이터 조회
    }

    if (complete) {
      setQuestionData(Array(5).fill('Y'));
    } else {
      setQuestionData(Array(5).fill(''));
    }

    const today = new Date();
    setTodayData(
      today.getFullYear() +
        '년 ' +
        (today.getMonth() + 1) +
        '월 ' +
        today.getDate() +
        '일',
    );
  }, []);

  const handleCheckBox = (findIndex, value) => {
    setQuestionData(
      questionData.map((item, index) => {
        return findIndex === index ? value : item;
      }),
    );

    if (value === 'N' && allCheckYN) {
      setAllCheckYN(false);
    }
  };

  // 붙여넣기 서명 조회
  const handlePasteCheck = value => {
    if (value && !isPracticeMode) {
      searchPasteSignData();
    }
    setPasteCheck(value);
  };

  const handleButtonClick = () => {
    if (
      questionData.includes('N') ||
      questionData.includes('') ||
      !signNameData ||
      !signatureData
    ) {
      setShowErrorCheckMsg(true);
      validationScrollMove();
    } else {
      onSave(
        signNameData,
        signatureData,
        'app_form_etc_42',
        `${reportId}_signid_02`,
        `${reportId}_signid_01`,
      );
    }
  };

  // 입력 오류 항목 최상단에 스크롤 위치
  const validationScrollMove = () => {
    const scrollWrapY = document
      .getElementById('scrollWrap')
      .getBoundingClientRect().top; // 스크롤 영역의 y좌표
    const currentScrollTop = document.getElementById('scrollWrap').scrollTop;
    const targetIndex = questionData.findIndex(
      item => item === 'N' || item === '',
    );

    if (targetIndex >= 0) {
      const targetY = document
        .getElementById(`q${targetIndex}`)
        .getBoundingClientRect().top;

      document.getElementById('scrollWrap').scrollTop =
        currentScrollTop + (targetY - scrollWrapY);
    } else if (!signNameData || !signatureData) {
      const targetY = document
        .getElementById('signDataWrap')
        .getBoundingClientRect().top;

      document.getElementById('scrollWrap').scrollTop =
        currentScrollTop + (targetY - scrollWrapY);
    }
  };

  const questionList = [
    '1. 청약의 변경으로 기본보험료 또는 보험가입금액이 감액되는 경우 줄어든 보험료를 기준으로 해약환급금이 변경되며 상품 특성 상에 따라 가입 초기에는 해약환급금이 없거나 가입시 안내한 해약환급금보다 적을 수 있다는 내용을 보험설계사로 부터 설명받으셨으며, 이에 동의하십니까?',
    '2. 최초 청약 시 제공받은 상품설명서의 해약환급금 예시 등은 청약 변경으로 인해 변경된다는 사실을 보험설계사로부터 설명 받으셨으며, 이에 대해 이의가 없으십니까? (변경 사항이 반영된 상품설명서의 해약환급금 예시는 담당 보험설계사를 통해 발급받으실 수 있습니다.)',
    '3. 청약 변경으로 감액되는 주계약 또는 특약으로 인해 보장내용이 달라진다는 사실을 보험설계사로부터 설명 들으셨으며 이에 동의하십니까?',
    '4. 청약 변경이 성립된 후 청약변경의 취소는 불가하다는 내용을 설명 들으셨으며 청약변경의 취소 불가에 대해 동의하십니까?',
    '5. 최초 청약시 받으신 청약서 부본 및 상품설명서의 보장내용과 청약 변경으로 변경된 보장 내용의 차이를 이해하셨으며 이의를 제기하지 않을 것에 동의하십니까?',
  ];
  return (
    <React.Fragment>
      <header className="modal-header">
        <h3 className="layer-tit2">주요내용 확인</h3>
      </header>
      <div className="cont modal-scroll-wrap" id="scrollWrap">
        <div className="infor-list">
          <div className="insu-box">
            <div className="txt-question w100 flex-none">
              <p>아래 문항에 체크 및 서명해주세요.</p>
            </div>
            <div className="inp-list2">
              <SatCheckBox
                value={[allCheckYN]}
                options={[{ label: '모두 설명받았다.', value: true }]}
                onChange={v => {
                  setAllCheckYN(v);
                  setQuestionData(
                    Array(questionList.length).fill(v ? 'Y' : ''),
                  );
                }}
              />
            </div>
          </div>
        </div>

        {questionList.map((option, index) => {
          return (
            <React.Fragment key={index}>
              <div
                id={`q${index}`}
                className={`infor-list ${
                  index === questionList.length - 1 && 'bdb-0 mgb-25'
                }`}
              >
                <SatQuestionArea
                  title={() => <p>{option}</p>}
                  selectValue={questionData[index]}
                  options={[
                    { label: '설명받았다', value: 'Y' },
                    { label: '설명받지 못했다', value: 'N' },
                  ]}
                  useType={'checkBox'}
                  onClick={(checkValue, optionValue) =>
                    checkValue && handleCheckBox(index, optionValue)
                  }
                  listType="inp-list2"
                  error={
                    showErrorCheckMsg &&
                    (questionData[index] === ''
                      ? '내용을 확인하고 선택해 주세요.'
                      : questionData[index] === 'N' &&
                        '선택하신 항목으로는 청약을 진행할 수 없습니다.')
                  }
                />
              </div>
            </React.Fragment>
          );
        })}

        <div className="info-box bg-yellow">
          <p className="text-info3 asterisk-type">
            계약자 및 피보험자 동의사항
          </p>
          <p className="text-info3">
            1. 위 내용은 계약자 및 피보험자 본인이 {todayData}에
            KB라이프생명보험에 가입한 청약 내용이며, 상기와 같이 청약 변경할
            것을 동의합니다.
          </p>
          <p className="text-info3">
            2. 상기의 청약 변경사항에 대해 이의가 없음을 동의합니다.
          </p>
        </div>

        <SatCheckBox
          value={[pasteCheck]}
          type={'radio'}
          options={[
            { label: '저장했던 성명/서명을 붙여넣으세요.', value: false },
          ]}
          onChange={v => handlePasteCheck(v)}
          customStyleClass="small w-360"
        />
        <div className="sign-pad-wrap" id="signDataWrap">
          <SatSignPad
            canvasRef={canvasSignNameRef}
            name={ownerName}
            title={'계약자 성명 입력'}
            error={
              showErrorCheckMsg && !signNameData ? '성명을 입력해주세요.' : ''
            }
            pasteCheck={pasteCheck}
            pasteData={
              !isPracticeMode
                ? signPasteData.app_form_etc_18_sign_01
                : practiceSignName
            }
            signData={complete ? signData.app_form_etc_42_signid_01 : ''}
            onChange={value => setSignNameData(value)}
            onChangePasteCheck={value => setPasteCheck(value)}
          />
          <SatSignPad
            canvasRef={canvasSignatureRef}
            name={'서명'}
            title={'계약자 서명 입력'}
            error={
              showErrorCheckMsg && !signatureData ? '서명을 입력해주세요.' : ''
            }
            pasteCheck={pasteCheck}
            pasteData={
              !isPracticeMode
                ? signPasteData.app_form_etc_18_sign_02
                : practiceSignature
            }
            signData={complete ? signData.app_form_etc_42_signid_02 : ''}
            onChange={value => setSignatureData(value)}
            onChangePasteCheck={value => setPasteCheck(value)}
          />
        </div>
      </div>
      <div className="layer-footer">
        <SatButton
          styleClass={`btn-s blue btn-wide ${
            questionData.includes('N') ||
            questionData.includes('') ||
            !signNameData ||
            !signatureData
              ? 'disabled'
              : ''
          }`}
          label={'확인'}
          onClick={() => handleButtonClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default ConstractChangePopup;
